import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 14a6 6 0 110-12 6 6 0 010 12zm0-2a4 4 0 100-8 4 4 0 000 8z"/>
    <path fill="#34CEFF" d="M18 23h2v-2a5 5 0 00-5-5H9a5 5 0 00-5 5v2h2v-2a3 3 0 013-3h6a3 3 0 013 3v2z"/>
  </SvgIcon>
);